module.exports = __webpack_public_path__ + "static/media/focus-active-cercle.41b34ee3.png";